import { featureFlagKeys } from '../common/drawers/featureFlagDrawer/const/featureFlagKeys';
import { isAuthenticated, withFeatureFlag } from '../common/permissions';
import { Dashboard } from './Dashboard';
import { MultiSiteDashboard } from './MultiSiteDashboard';

export default [
  {
    exact: true,
    path: '/home',
    helpId: 'dashboard',
    permissions: [isAuthenticated],
    component: Dashboard,
  },
  {
    exact: true,
    path: '/home/multisite-beta',
    helpId: 'dashboard',
    permissions: [
      isAuthenticated,
      withFeatureFlag(featureFlagKeys.isMultisiteFunctionalityAvailable),
    ],
    component: MultiSiteDashboard,
  },
];
